import { ApiUrls } from '@/service/constants/urls';
import { TAddCartPromoApiBody, TAddCartPromoApiParams } from '@/domain/Cart.domain';
import { instance } from '../Axios';
import { replaceLightframe } from '@/service/utils/replaceLightframe';

export const addCartPromoApi = async (
    { id, partnerId }: TAddCartPromoApiParams,
    body: TAddCartPromoApiBody
): Promise<void> =>
    instance.post(
        `${ApiUrls.cart.promo.add}/${id}?partnerId=${replaceLightframe(partnerId)}`,
        body
    );
